/*eslint-disable no-constant-condition */
import { Card } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import '../../coverage/index.scss';
import React from 'react';
import Skeleton from '../../memberSkeleton';
import { useSelector } from 'react-redux';
import { ProgressIndicator } from './ProgressIndicator';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});
const CopaymentNetwork = (CopaymentData) => {
  const { Value_Network_For_Coverage_Admin } =
    useSelector((state) => state.app.appConfigs.Network_Setting) || 'network';
  let accumsLabel = '';
  if (CopaymentData?.network === 'In Network') {
    if (CopaymentData?.networkProps?.label) {
      if (CopaymentData?.networkProps?.label !== 'ALL') {
        accumsLabel = CopaymentData?.networkProps.label;
      } else {
        accumsLabel = 'In-Network ';
      }
    } else {
      accumsLabel = 'In-Network ';
    }
  }
  if (CopaymentData?.network === 'Out of Network') {
    if (Value_Network_For_Coverage_Admin === 'tier') {
      let networkTier = '';
      CopaymentData.networkPlandetails &&
        CopaymentData.networkPlandetails.map((data) => {
          if (data.BenefitScheduleType === 'Out-Of-Area') {
            networkTier = data.NetworkTier;
          }
        });
      if (networkTier) {
        accumsLabel = networkTier;
      } else {
        accumsLabel = 'Out-of-Network';
      }
    } else {
      accumsLabel = 'Out-of-Network';
    }
  }
  if (CopaymentData?.network === 'Penalty') {
    if (Value_Network_For_Coverage_Admin === 'tier') {
      let networkTier = '';
      CopaymentData.networkPlandetails &&
        CopaymentData.networkPlandetails.map((data) => {
          if (data.BenefitScheduleType === 'Penalty') {
            networkTier = data.NetworkTier;
          }
        });
      if (networkTier) {
        accumsLabel = networkTier;
      } else {
        accumsLabel = 'Out-of-Network Penalty';
      }
    } else {
      accumsLabel = 'Out-of-Network Penalty';
    }
  }
  return CopaymentData?.isAPIFailed ? (
    CopaymentData?.isNotFound ? (
      <Card>
        <Card.Header>
          <h5>{accumsLabel}</h5>
        </Card.Header>
        <Card.Body className="pt-4">
          <Card.Text>Copay Details Not Available</Card.Text>
        </Card.Body>
      </Card>
    ) : (
      <Card>
        <Card.Header>
          <h5>{CopaymentData?.network}</h5>
        </Card.Header>
        <Card.Body className="pt-4">
          <Card.Text>Unable to retrieve details</Card.Text>
        </Card.Body>
      </Card>
    )
  ) : CopaymentData?.dataFetching ? (
    <Skeleton />
  ) : (
    <>
      {CopaymentData?.NetworkExclusionFlag === false ? (
        <Card>
          <Card.Header>
            <h5>{accumsLabel}</h5>
          </Card.Header>
          <Card.Body className="pt-4">
            {CopaymentData?.coverageCopayments?.coPaymentExists === true ? (
              <>
                <>
                  {CopaymentData?.coverageCopayments?.coPaymentAmount !==
                    'NA' ||
                  CopaymentData?.coverageCopayments?.deductiableIsWaivedOff !==
                    'NA' ||
                  CopaymentData?.coverageCopayments?.coInsurancePercentage !==
                    'NA' ? (
                    <>
                      {CopaymentData?.coverageCopayments
                        ?.coInsurancePercentage !== 100 ? (
                        <>
                          {CopaymentData?.coverageCopayments
                            ?.coPaymentAmount !== 'NA' ||
                          CopaymentData?.coverageCopayments
                            ?.deductiableIsWaivedOff !== 'NA' ? (
                            <>
                              {CopaymentData?.coverageCopayments
                                ?.coPaymentAmount !== 'NA' && (
                                <Card.Text className="co-PayText">
                                  You Pay{' '}
                                  <b className="co-PayValue">
                                    {
                                      CopaymentData?.coverageCopayments
                                        ?.coPaymentAmount
                                    }{' '}
                                    <Badge pill>Copay</Badge>
                                  </b>
                                </Card.Text>
                              )}
                              {CopaymentData?.coverageCopayments
                                ?.coInsurancePercentage !== 'NA' && (
                                <Card.Text className="card-text-family">
                                  {CopaymentData?.coverageCopayments
                                    ?.coInsurancePercentage >= 0 && (
                                    <b className="co-pay">
                                      {
                                        CopaymentData?.coverageCopayments
                                          ?.coInsurancePercentage
                                      }
                                      %{' '}
                                    </b>
                                  )}
                                  {CopaymentData?.coverageCopayments
                                    ?.coInsurancePercentage !== 100 && (
                                    <>
                                      {CopaymentData?.coverageCopayments
                                        ?.deductiableIsWaivedOff === false ? (
                                        <span>
                                          Co-Insurance
                                          {/*from your Out of Pocket */}
                                        </span>
                                      ) : (
                                        <span>
                                          Co-Insurance
                                          {/*until from your Out of Pocket */}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </Card.Text>
                              )}
                              {CopaymentData?.coverageCopayments
                                ?.deductiableIsWaivedOff === true && (
                                <Card.Text className="card-text-family">
                                  Deductible Waived
                                </Card.Text>
                              )}
                              {CopaymentData?.coverageCopayments
                                ?.deductiableIsWaivedOff === false && (
                                <Card.Text className="card-text-family">
                                  Deductible Applies
                                </Card.Text>
                              )}
                            </>
                          ) : (
                            <>
                              <Card.Text className="co-PayText">
                                You Pay{' '}
                                <b className="co-PayValue">
                                  {
                                    CopaymentData?.coverageCopayments
                                      ?.coInsurancePercentage
                                  }
                                  %{' '}
                                </b>{' '}
                                Co-Insurance from your Out of Pocket max
                              </Card.Text>
                              {CopaymentData?.coverageCopayments
                                ?.deductiableIsWaivedOff === true && (
                                <Card.Text className="card-text-family">
                                  Deductible Waived
                                </Card.Text>
                              )}
                              {CopaymentData?.coverageCopayments
                                ?.deductiableIsWaivedOff === false && (
                                <Card.Text className="card-text-family">
                                  Deductible Applies
                                </Card.Text>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <Card.Text className="co-PayText">
                            {' '}
                            You Pay <b className="co-PayValue">100%</b>
                          </Card.Text>
                          {CopaymentData?.coverageCopayments
                            ?.deductiableIsWaivedOff === true && (
                            <Card.Text className="card-text-family">
                              Deductible Waived
                            </Card.Text>
                          )}
                          {CopaymentData?.coverageCopayments
                            ?.deductiableIsWaivedOff === false && (
                            <Card.Text className="card-text-family">
                              Deductible Applies
                            </Card.Text>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {<Card.Text className="co-PayText">Copay- N/A</Card.Text>}
                    </>
                  )}
                </>
                {CopaymentData?.coverageCopayments?.preCertification ===
                  'Y' && (
                  <Card.Text className="card-text-family">
                    Precertification Required
                  </Card.Text>
                )}
              </>
            ) : (
              <>
                <Card.Text className="co-PayText">Copay- N/A</Card.Text>
                {CopaymentData?.coverageCopayments?.coInsurancePercentage &&
                  CopaymentData?.coverageCopayments?.coInsurancePercentage !==
                    'NA' && (
                    <Card.Text>
                      <b className="co-pay">
                        {
                          CopaymentData?.coverageCopayments
                            ?.coInsurancePercentage
                        }
                        %{' '}
                      </b>{' '}
                      <span>Co-Insurance</span>
                    </Card.Text>
                  )}
                {CopaymentData?.coverageCopayments?.deductiableIsWaivedOff ===
                  true && (
                  <Card.Text className="card-text-family">
                    Deductible Waived
                  </Card.Text>
                )}
                {CopaymentData?.coverageCopayments?.deductiableIsWaivedOff ===
                  false && (
                  <Card.Text className="card-text-family">
                    Deductible Applies
                  </Card.Text>
                )}
                {CopaymentData?.coverageCopayments?.preCertification ===
                  'Y' && (
                  <Card.Text className="card-text-family">
                    Precertification Required
                  </Card.Text>
                )}
              </>
            )}
            {CopaymentData?.coverageCopayments?.lifeTimeMaxAmount !== 'NA' ||
            CopaymentData?.coverageCopayments?.lifeTimeMaxVisits !== 'NA' ||
            CopaymentData?.coverageCopayments?.annualMaxAmount !== 'NA' ||
            CopaymentData?.coverageCopayments?.annualMaxVisits !== 'NA' ? (
              <>
                {
                  <>
                    <Card.Text className="benifit-limitations-label cost-card-text">
                      Benefit Limitations:
                    </Card.Text>
                    {(CopaymentData?.coverageCopayments?.annualMaxAmount !==
                      'NA' ||
                      CopaymentData?.coverageCopayments?.annualAccumAmount !==
                        'NA') && (
                      <Card.Text className="cost-card-text">
                        {CopaymentData?.coverageCopayments?.annualMaxAmount !==
                          'NA' &&
                          CopaymentData?.coverageCopayments?.annualMaxAmount <
                            9999999 && (
                            <span>
                              <b className="co-pay-limit">
                                {formatter.format(
                                  parseFloat(
                                    CopaymentData?.coverageCopayments
                                      ?.annualMaxAmount,
                                  ).toFixed(2),
                                )}
                              </b>
                              &nbsp;&nbsp;
                            </span>
                          )}
                        {(CopaymentData?.coverageCopayments?.annualMaxAmount !==
                          'NA' ||
                          (CopaymentData?.coverageCopayments
                            ?.annualAccumAmount !== 'NA' &&
                            CopaymentData?.coverageCopayments
                              ?.annualAccumAmount > 0)) &&
                          (CopaymentData?.coverageCopayments
                            ?.annualMaxAmount !== 'NA' &&
                          CopaymentData?.coverageCopayments?.annualAccumAmount >
                            CopaymentData?.coverageCopayments
                              ?.annualMaxAmount ? (
                            <p>
                              Annual{' '}
                              <b className="co-pay-limit">(100%&nbsp;Used)</b>
                            </p>
                          ) : (
                            <span>
                              Annual&nbsp;(
                              <b className="co-pay-limit">
                                $
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.annualAccumAmount
                                }
                              </b>
                              &nbsp;Used){' '}
                            </span>
                          ))}
                      </Card.Text>
                    )}
                    {(CopaymentData?.coverageCopayments?.lifeTimeMaxAmount !==
                      'NA' ||
                      CopaymentData?.coverageCopayments?.lifeTimeAccumAmount !==
                        'NA') && (
                      <Card.Text className="cost-card-text">
                        {CopaymentData?.coverageCopayments
                          ?.lifeTimeMaxAmount !== 'NA' &&
                          CopaymentData?.coverageCopayments?.lifeTimeMaxAmount <
                            9999999 && (
                            <span>
                              <b className="co-pay-limit">
                                {formatter.format(
                                  parseFloat(
                                    CopaymentData?.coverageCopayments
                                      ?.lifeTimeMaxAmount,
                                  ).toFixed(2),
                                )}{' '}
                              </b>
                              &nbsp;
                            </span>
                          )}
                        {(CopaymentData?.coverageCopayments
                          ?.lifeTimeMaxAmount !== 'NA' ||
                          (CopaymentData?.coverageCopayments
                            ?.lifeTimeAccumAmount !== 'NA' &&
                            CopaymentData?.coverageCopayments
                              ?.lifeTimeAccumAmount > 0)) &&
                          (CopaymentData?.coverageCopayments
                            ?.lifeTimeMaxAmount !== 'NA' &&
                          CopaymentData?.coverageCopayments
                            ?.lifeTimeAccumAmount >
                            CopaymentData?.coverageCopayments
                              ?.lifeTimeMaxAmount ? (
                            <p>
                              Lifetime{' '}
                              <b className="co-pay-limit">(100%&nbsp;Used)</b>
                            </p>
                          ) : (
                            <span>
                              Lifetime&nbsp;(
                              <b className="co-pay-limit">
                                $
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.lifeTimeAccumAmount
                                }{' '}
                              </b>
                              &nbsp;Used)
                            </span>
                          ))}
                      </Card.Text>
                    )}
                    {(CopaymentData?.coverageCopayments?.annualMaxVisits !==
                      'NA' ||
                      (CopaymentData?.coverageCopayments?.annualAccumVisits !==
                        'NA' &&
                        CopaymentData?.coverageCopayments?.annualAccumVisits >
                          0)) && (
                      <Card.Text className="cost-card-text">
                        {CopaymentData?.coverageCopayments?.annualMaxVisits !==
                          'NA' &&
                          CopaymentData?.coverageCopayments?.annualMaxVisits <
                            9999999 && (
                            <span>
                              <b className="co-pay-limit">
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.annualMaxVisits
                                }
                              </b>
                              &nbsp;&nbsp;
                            </span>
                          )}
                        {(CopaymentData?.coverageCopayments?.annualMaxVisits !==
                          'NA' ||
                          (CopaymentData?.coverageCopayments
                            ?.annualAccumVisits !== 'NA' &&
                            CopaymentData?.coverageCopayments
                              ?.annualAccumVisits > 0)) &&
                          (CopaymentData?.coverageCopayments
                            ?.annualAccumVisits !== 'NA' &&
                          CopaymentData?.coverageCopayments?.annualAccumVisits >
                            CopaymentData?.coverageCopayments
                              ?.annualMaxVisits ? (
                            <p>
                              Visits Annual{' '}
                              <b className="co-pay-limit">
                                (100%&nbsp;Visits Used)
                              </b>
                            </p>
                          ) : (
                            <span>
                              Visits Annual&nbsp;(
                              <b className="co-pay-limit">
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.annualAccumVisits
                                }
                              </b>
                              &nbsp;
                              {CopaymentData?.coverageCopayments
                                ?.annualAccumVisits > 1
                                ? 'Visits Used'
                                : 'Visit Used'}
                              )
                            </span>
                          ))}
                      </Card.Text>
                    )}
                    {(CopaymentData?.coverageCopayments?.lifeTimeMaxVisits !==
                      'NA' ||
                      (CopaymentData?.coverageCopayments
                        ?.lifeTimeAccumVisits !== 'NA' &&
                        CopaymentData?.coverageCopayments?.lifeTimeAccumVisits >
                          0)) && (
                      <Card.Text className="cost-card-text">
                        {CopaymentData?.coverageCopayments
                          ?.lifeTimeMaxVisits !== 'NA' &&
                          CopaymentData?.coverageCopayments?.lifeTimeMaxVisits <
                            9999999 && (
                            <span>
                              <b className="co-pay-limit">
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.lifeTimeMaxVisits
                                }
                              </b>
                              &nbsp;&nbsp;
                            </span>
                          )}
                        {(CopaymentData?.coverageCopayments
                          ?.lifeTimeMaxVisits !== 'NA' ||
                          (CopaymentData?.coverageCopayments
                            ?.lifeTimeAccumVisits !== 'NA' &&
                            CopaymentData?.coverageCopayments
                              ?.lifeTimeAccumVisits > 0)) &&
                          (CopaymentData?.coverageCopayments
                            ?.lifeTimeAccumVisits !== 'NA' &&
                          CopaymentData?.coverageCopayments
                            ?.lifeTimeAccumVisits >
                            CopaymentData?.coverageCopayments
                              ?.lifeTimeMaxVisits ? (
                            <p>
                              Visits Lifetime{' '}
                              <b className="co-pay-limit">
                                (100%&nbsp;Visits Used)
                              </b>
                            </p>
                          ) : (
                            <span>
                              Visits Lifetime&nbsp;(
                              <b className="co-pay-limit">
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.lifeTimeAccumVisits
                                }
                              </b>
                              &nbsp;
                              {CopaymentData?.coverageCopayments
                                ?.lifeTimeAccumVisits > 1
                                ? 'Visits Used'
                                : 'Visit Used'}
                              )
                            </span>
                          ))}
                      </Card.Text>
                    )}
                  </>
                }
              </>
            ) : (
              <Card.Text>
                Consult the Benefit Summary document for further information
              </Card.Text>
            )}
          </Card.Body>
          <div className="grpDivider ml-3 mr-3"></div>
          <div className="mt-3 ml-3 mr-3">
            <ProgressIndicator
              label="Deductible"
              max={CopaymentData?.coverageCopayments?.deductible?.Max}
              applied={CopaymentData?.coverageCopayments?.deductible?.Met}
              remaining={
                CopaymentData?.coverageCopayments?.deductible?.Remaining
              }
              Value_Network_For_Coverage_Admin={
                Value_Network_For_Coverage_Admin
              }
            />
          </div>
          <div className="mb-3 ml-3 mr-3">
            <ProgressIndicator
              label="Out-of-pocket"
              OutOfPocket={true}
              max={CopaymentData?.coverageCopayments?.outPfPocket?.Max}
              applied={CopaymentData?.coverageCopayments?.outPfPocket?.Met}
              remaining={
                CopaymentData?.coverageCopayments?.outPfPocket?.Remaining
              }
              Value_Network_For_Coverage_Admin={
                Value_Network_For_Coverage_Admin
              }
            />
          </div>
        </Card>
      ) : (
        <Card>
          <Card.Header>
            <h5>{accumsLabel}</h5>
          </Card.Header>
          <Card.Body className="pt-4">
            <Card.Text>Not Covered</Card.Text>
          </Card.Body>
          <div className="grpDivider ml-3 mr-3"></div>
          <div className="mt-3 ml-3 mr-3">
            <ProgressIndicator
              label="Deductible"
              max={CopaymentData?.coverageCopayments?.deductible?.Max}
              applied={CopaymentData?.coverageCopayments?.deductible?.Met}
              remaining={
                CopaymentData?.coverageCopayments?.deductible?.Remaining
              }
              Value_Network_For_Coverage_Admin={
                Value_Network_For_Coverage_Admin
              }
            />
          </div>
          <div className="mb-3 ml-3 mr-3">
            <ProgressIndicator
              label="Out-of-pocket"
              OutOfPocket={true}
              max={CopaymentData?.coverageCopayments?.outPfPocket?.Max}
              applied={CopaymentData?.coverageCopayments?.outPfPocket?.Met}
              remaining={
                CopaymentData?.coverageCopayments?.outPfPocket?.Remaining
              }
              Value_Network_For_Coverage_Admin={
                Value_Network_For_Coverage_Admin
              }
            />
          </div>
        </Card>
      )}
    </>
  );
};
export default CopaymentNetwork;
